import script from "./AddStudentToGuardianForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddStudentToGuardianForm.vue?vue&type=script&setup=true&lang=js"

import "./AddStudentToGuardianForm.vue?vue&type=style&index=0&id=4af426c9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af426c9"]])

export default __exports__